<div class="app-container">
  <page-header [icon]="'far-credit-card'" [title]="'payments'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/payment']"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [label]="'payment.create'"
          [title]="'payment.create' | translate"
          [dataCyAttribute]="'go-payment'"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'payments'"
      (onSubmit)="queryPayments.refetch()"
      (onClearClick)="clearFilters()"
      [isFilterInvisible]="true"
      [totalItems]="totalItems()"
    >
      <form-row-input
        [model]="filters().name"
        (modelChange)="onNameFilterChange($event)"
        [icon]="'far-list'"
        [label]="'payment.name'"
        (keydown.enter)="queryPayments.refetch()"
        [dataCyAttribute]="'payment-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'payments'"
      [query]="queryPayments"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
